import { Box, Chip, IconButton, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserTagDataFragment } from '../../../api';
import useCommonStyles from '../../../useCommonStyles';

export type TagRowProps = {
    tag: UserTagDataFragment;
    onEdit: () => void;
    onDelete: () => void;
};

const useStyles = makeStyles({
    tagChip: {
        backgroundColor: '#f0ece1',
        color: '#8a7a4f',
        borderRadius: 5,
        fontSize: 16,
        fontWeight: 400,
        height: 32,
    },
    tagChipLabel: {
        paddingLeft: 12,
        paddingRight: 12,
    },
});

const TagRow = ({ tag, onEdit, onDelete }: TagRowProps) => {
    const commonStyles = useCommonStyles();
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <TableRow className={commonStyles.tableRow}>
            <TableCell>
                <Chip
                    className={classes.tagChip}
                    classes={{
                        label: classes.tagChipLabel,
                    }}
                    label={tag.name}
                    size="small"
                />
            </TableCell>
            <TableCell align="left">{t('tagManagementPage:dealersNumber', { number: tag.userIds.length })}</TableCell>
            <TableCell align="right">
                <Box
                    className={commonStyles.buttonGroup}
                    sx={{
                        width: 60,
                        ml: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                    }}
                >
                    <IconButton aria-label={t('common:edit')} color="secondary" onClick={onEdit}>
                        <EditIcon />
                    </IconButton>

                    <IconButton aria-label={t('common:delete')} color="secondary" onClick={onDelete}>
                        <DeleteIcon />
                    </IconButton>
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default TagRow;
